<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="名称、单号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
        ></el-input>
        <el-date-picker
          v-model="state.params.month"
          type="month"
          format="YYYY年M月"
          value-format="YYYY-MM"
          placeholder="薪资所属期"
          style="width: 200px"
        />
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="--发放日期--"
          end-placeholder="--发放日期--"
          style="width: 300px"
          @change="onDateChange"
          value-format="YYYY-MM-DD"
          @clear="delete state.params.pay_date"
        />
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/单号"
          prop="status"
          sortable="status"
          width="140"
          fixed="left"
        >
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <text :style="{ color: row.status == 0 ? '#1e90ff' : '#080' }">
                  {{ row.status == 0 ? "操作中" : "已完成" }}
                </text>
              </template>
              <template #bottom>
                <text
                  style="color: #1e90ff"
                  class="text-hover-decoration"
                  title="工资表单号"
                  @click="$onCopy(row.order_id)"
                >
                  {{ row.order_id }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          sortable="name"
          label="名称"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          :min-width="220"
        />
        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_ShowToolTip"
          :min-width="220"
        />
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_ShowToolTip"
          :width="120"
        />
        <el-table-column
          prop="d_service_name"
          label="客户服务类型"
          :formatter="$tab_ShowToolTip"
          :width="120"
        />
        <el-table-column
          prop="d_tax_type_name"
          label="报税类型"
          :formatter="$tab_ShowToolTip"
          :width="160"
        />
        <el-table-column
          prop="tax_month"
          label="税款所属期"
          :formatter="$tab_ShowToolTip"
          :width="120"
        />
        <el-table-column
          prop="pay_date"
          label="发放日期"
          :formatter="$tab_ShowToolTip"
          :width="120"
        />
        <el-table-column
          prop="employee_num"
          label="员工数量"
          :formatter="$tab_NumberFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="settle_amount"
          label="结算金额"
          :formatter="$tab_MoneyFormat"
          align="center"
          :width="160"
          fixed="right"
        />
        <el-table-column
          prop="unpaied_amount"
          label="欠款"
          :formatter="$tab_PriceFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="receipt_amount"
          label="已发放"
          :formatter="$tab_PriceFormat"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="belonger_name"
          label="负责人"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.belonger_name,
                row.belonger_department_name || ''
              )
          "
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="View"
              @click="
                state.selectItem = row;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        @onLoad="
          (pageIndex) => {
            state.params.page = pageIndex;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showDetail"
      :title="state.selectItem?.name + '-工资表详情'"
      @close="state.showDetail = false"
    >
      <c_PayrollDetail
        :id="state.selectItem.id"
        @close="state.showDetail = false"
      ></c_PayrollDetail>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { payroll_list } from "@/http/api";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      payroll_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onDateChange = (value) => {
      if (value && value.length == 2)
        state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.dates;
      Object.assign(state, new InitFormData());
      onLoad();
    };
    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDateChange,
    };
  },
};
</script>
<style scoped></style>
